import CollapsibleTable from "../../tableComponents/CollapsibleTable";
import React, {useEffect, useState} from "react";
import {createColumn, createComponentColumn} from "../../../utils/ColumnUtils";
import {useHttp} from "../../../services/HttpService";
import {getDigiWabUrlEndpoint, getWasserrechteEndpoint} from "../../../services/BescheidsService";
import routes from "../../../consts/routes.json";
import {useLocation} from "react-router-dom";

/**
 * Component für die Anzeige von Wasserrechten in einer CollapsibleTable.
 * @param wasserrechte die Wasserrechte, die dargestellt werden sollen
 * @param style
 * @returns {JSX.Element}
 * @constructor
 */
const Wasserrechte = ({
                          bescheidId,
                          style
                      }) => {
    const [digiWabUrl, fetchDigiWabUrl] = useHttp(getDigiWabUrlEndpoint(), {manual: true});
    const [wasserrechte, fetchWasserrechte] = useHttp(getWasserrechteEndpoint(bescheidId), {manual: true});
    const [lastBescheidId, setLastBescheidId] = useState(bescheidId);

    const location = useLocation();

    useEffect(() => {
        if (!digiWabUrl.loading && !digiWabUrl.error && !digiWabUrl.data &&
            !wasserrechte.loading && !wasserrechte.error && !wasserrechte.data &&
            bescheidId && bescheidId !== lastBescheidId) {

            fetchWasserrechte().catch(() => {
                // Do nothing
            });
            fetchDigiWabUrl().catch(() => {
                // Do nothing
            })
            setLastBescheidId(bescheidId);
        }
    }, [digiWabUrl.loading, digiWabUrl.error, digiWabUrl.data, fetchDigiWabUrl, wasserrechte.loading, wasserrechte.error, wasserrechte.data, fetchWasserrechte, bescheidId, lastBescheidId]);

    const linkColumnComponentProvider = (row, index) => {
        return (
            <a
                target="_blank"
                href={calculateWasserbuchLink(row)}
                rel="noopener noreferrer"
            >
                {row.wasserrechtNr}
            </a>
        );
    };

    function calculateWasserbuchLink(row) {
        return location.pathname.replaceAll(/betriebsakte.*$/g, routes.WASSERBUCH) + '/wbb' + row.id + '?wbbId=' + row.id;
    }

    const columns = [
        createColumn("anlage.value", "Abwasseranlage"),
        createComponentColumn("wasserrechtNr", linkColumnComponentProvider, "Wasserbuch-Nr."),
        createColumn("gewaesser", "Gewässer"),
        createColumn("benutzung", "Nutzung"),
        createColumn("status", "Status"),
    ];

    return (
        <CollapsibleTable
            id="bescheid_wasserrechte"
            label="Zugeordnete Wasserrechte"
            data={wasserrechte?.data ? wasserrechte.data : []}
            columns={columns}
            style={style}
        />
    );
};

export default Wasserrechte;
